import React, { useEffect, useState } from "react";
import {
  Card,
  Select,
  Input,
  Button,
  Typography,
  Row,
  Col,
  Modal,
  message,
  Popconfirm,
} from "antd";
import { CarTwoTone, SearchOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import icon from "../assets/images/protection.png";
import Title from "antd/es/typography/Title";
import colors from "../../assets/styles/colour";
import dataService from "../../networks/api/service/dataService";
import { useLocation, useNavigate } from "react-router-dom";
import { mode } from "crypto-js";
import { AiOutlinePlusCircle } from "react-icons/ai";
const { Option } = Select;


const VehicleManagement = () => {
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [vehicleData, setVehicleData] = useState([]);
  const [vehicleList, setVehicleList] = useState(vehicleData);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await dataService.getAllVehicle();
        console.log("Fetched Drivers:", response?.data);
        setVehicleData(response?.data || []);
        setVehicleList(response?.data || []);
      } catch (error) {
        console.error("Failed to fetch drivers:", error);
      }
    };

    fetchVehicles();
  }, []);

const filteredVehicles = vehicleData.filter((vehicle) => {
  const statusMatch =
    statusFilter === "all" ||
    (statusFilter === "Available" && vehicle.isAssigned === false) ||
    (statusFilter === "Unavailable" && vehicle.isAssigned === true);

  const searchLower = search.toLowerCase();

  const searchMatch =
    (vehicle.makeAndModel || "").toLowerCase().includes(searchLower) ||
    (vehicle.registrationNum || "").toLowerCase().includes(searchLower);

  return statusMatch && searchMatch;
});
  
// Add this helper above your return
const getVehicleImage = (vehicle) => {
  const type = (vehicle.vehicleDetails || "").toLowerCase();
  
  const isTwoWheeler =
    type.includes("2w") ||
    type.includes("two wheeler") ||
    type.includes("bike") ||
    type.includes("scooter") ||
    type.includes("motorcycle") ||
    type.includes("motorbike");

  if (isTwoWheeler) {
    // Colorful scooter/bike image (free, no auth required)
    return "https://static.vecteezy.com/system/resources/thumbnails/049/958/662/small/a-man-riding-a-motorcycle-on-a-black-background-png.png";
  }

  return vehicle.image || "https://cdn-icons-png.flaticon.com/512/3231/3231728.png";
};

  return (
    <div style={{ maxWidth: 1200, margin: " auto", padding: 20 }}>
      <motion.div
  initial={{ opacity: 0, y: -20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.5 }}
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap", // Enables wrapping on small screens
    gap: "10px", // Space between wrapped items
    marginBottom: 20,
  }}
>
  {/* Left: Icon + Title (centered together) */}
  <div style={{ display: "flex", alignItems: "center", flex: 1, minWidth: "250px", justifyContent: "center" }}>
    <motion.img
      src={icon}
      alt="Trip Icon"
      style={{ width: "50px", height: "50px", marginRight: "10px" }}
    />
    <Title
      level={3}
      style={{ margin: 0, textAlign: "center" }}
    >
      Vehicle Management
    </Title>
  </div>

  {/* Right: Button */}
  <div style={{ minWidth: "150px", textAlign: "right" }}>
    <Button
       icon = {<AiOutlinePlusCircle/>}
      onClick={() => navigate("/login/TransportDetails")}
      style={{
        backgroundColor: "rgba(128, 128, 128, 0.3)",
        borderColor: "rgba(128, 128, 128, 0.5)",
        color: "#333",
        backdropFilter: "blur(4px)",
        padding: "6px 16px",
        borderRadius: "8px",
        fontWeight: "500",
        transition: "all 0.3s ease",
        width: "100%", // Makes the button responsive on small screens
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(128, 128, 128, 0.5)";
        e.currentTarget.style.borderColor = "rgba(128, 128, 128, 0.7)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(128, 128, 128, 0.3)";
        e.currentTarget.style.borderColor = "rgba(128, 128, 128, 0.5)";
      }}
    >
      ADD VEHICLE
    </Button>
  </div>
</motion.div>

      {/* Filters */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <Select
          placeholder="Filter by Status"
          style={{ width: 200 }}
          onChange={setStatusFilter}
        >
          <Option value="all">All</Option>
          <Option value="Available">Available</Option>
          <Option value="In Service">In Service</Option>
          <Option value="Unavailable">Unavailable</Option>
        </Select>
        <Input
          placeholder="Search by Model or Reg. Number"
          prefix={<SearchOutlined style={{ color: colors.buttoSecondary }} />}
          style={{ width: 300 }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Vehicle Cards */}
      <Row gutter={[20, 20]}>
        {filteredVehicles.map((vehicle) => (
          <Col key={vehicle.id} xs={24} sm={12} md={8}>
            <motion.div whileHover={{ scale: 1.05 }}>
              <Card
                title={vehicle.makeAndModel}
                bordered={false}
                cover={
                  <img
                    alt="vehicle"
                   src={getVehicleImage(vehicle)}
                    style={{ height: 150, objectFit: "cover" }}
                  />
                }
                style={{
                  borderRadius: 10,
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <p>
                  <CarTwoTone /> Type: {vehicle.vehicleDetails}
                </p>
                <p>Registration: {vehicle.registrationNum}</p>
                <p>Insurance: {vehicle.insuranceProvider}</p>
                <p>Last Service: {vehicle.lastValidityDate}</p>
                <p>
                  Status:{" "}
                  <b
                    style={{
                      color: vehicle.isAssigned ? "red" : "green",
                    }}
                  >
                    {vehicle.isAssigned ? "Unavailable" : " Available "}
                  </b>
                </p>
                <Button
                  type="primary"
                  style={{
                    marginTop: 10,
                    backgroundColor: colors.buttoSecondary,
                    borderColor: colors.buttoSecondary,
                  }}
                  onClick={() => {
                    navigate('/login/VehicleDetaills', { state: { vehicleData: vehicle } });
                    console.log("anythig",vehicle)
                  }}
                 
                  block
                >
                  View Details
                </Button>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default VehicleManagement;
